import React from 'react';

const PatientFlow = () => {
  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h3 className="text-lg font-medium mb-3">Patient Flow</h3>
      
      <div className="flex justify-center mb-3">
        {/* Simple flow diagram */}
        <div className="flex flex-col items-center">
          <div className="flex mb-4">
            <div className="w-16 h-12 bg-blue-300 rounded mx-2 flex items-center justify-center">Check-in</div>
            <div className="w-16 h-12 bg-blue-300 rounded mx-2 flex items-center justify-center">Vitals</div>
            <div className="w-16 h-12 bg-blue-300 rounded mx-2 flex items-center justify-center">Visit</div>
          </div>
          
          <div className="flex">
            <div className="w-16 h-12 bg-blue-300 rounded mx-2 flex items-center justify-center">Labs</div>
            <div className="w-16 h-12 bg-blue-300 rounded mx-2 flex items-center justify-center">Imaging</div>
            <div className="w-16 h-12 bg-blue-300 rounded mx-2 flex items-center justify-center">Check-out</div>
          </div>
        </div>
      </div>
      
      <div className="space-y-1 text-sm">
        <div className="flex justify-between">
          <span>Avg wait time:</span>
          <span className="font-medium">12m</span>
        </div>
        <div className="flex justify-between">
          <span>Bottleneck:</span>
          <span className="font-medium text-red-500">Labs</span>
        </div>
      </div>
    </div>
  );
};

export default PatientFlow;